import PropTypes from 'prop-types';

export default function PageHeader({ title, subtitle, maxWidth = 'max-w-6xl' }) {
  return (
    <div className="relative overflow-hidden pt-20 pb-14 sm:pt-24 sm:pb-16" style={{ backgroundColor: '#08111F' }}>

      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-40"
           style={{ backgroundImage: 'linear-gradient(rgba(148,163,184,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.06) 1px, transparent 1px)', backgroundSize: '54px 54px' }}>
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 -right-20 h-[34rem] w-[34rem] rounded-full bg-blue-600/15 blur-[120px]"></div>

      <div className={`mx-auto ${maxWidth} px-6 lg:px-8 relative z-10`}>
        <div className="max-w-3xl lg:mx-0">

          <div className="mb-6 h-1 w-12 rounded-full bg-blue-600"></div>

          <h1 className="text-3xl font-bold tracking-tight text-white text-balance sm:text-5xl leading-tight">
            {title}
          </h1>

          {subtitle && (
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300 text-pretty sm:text-xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  maxWidth: PropTypes.string,
};
